const path = 'redux/opportunity';
export const OPPORTUNITIES_LOADED = `${path}/OPPORTUNITIES_LOADED`;
export const OPPORTUNITY_LOADED = `${path}/OPPORTUNITY_LOADED`;
export const OPPORTUNITY_PICKLISTS_LOADED = `${path}/OPPORTUNITY_PICKLISTS_LOADED`;
